export function httpConfig() {
  const http = "http://127.0.0.1:3200";
  const https = "https://127.0.0.1:4100";
  const http_host = "https://datasoft.co.th:4100";
  const http_ip = "http://localhost:3200";
  return http_host;
}

